<template>
  <div>
    <div v-if="error">{{error}}</div>
    <input
      ref="file_input"
      type="file"
      :accept="options.accept"
      @change="onPicked"
      style="display: none"
    />
    <v-btn flat v-if="!file" @click="pickFile"><v-icon>star</v-icon></v-btn>
    <v-btn flat v-if="file" @click="upload" :disabled="!file">
      <v-icon>cloud_upload</v-icon>
    </v-btn>
    <v-img v-if="file" :src="photoUrl" max-width="100%" />
  </div>
</template>

<script>
import { Logger } from '@aws-amplify/core';
import Storage from '@aws-amplify/storage';
import EventBus from '../../events/EventBus';
export default {
  name: 'IpWayPhotoPiker',
  props: ['photoPickerConfig'],
  data() {
    return {
      logger: {},
      file: null,
      s3ImagePath: '',
      photoUrl: '',
      error: ''
    };
  },
  computed: {
    options() {
      const defaults = {
        accept: '*/*',
        storageOptions: {}
      };
      return Object.assign(defaults, this.photoPickerConfig || {});
    }
  },
  mounted() {
    this.logger = new Logger(this.$options.name);

    if (!this.options.path) {
      return this.setError('File path not provided.');
    }
    if (this.options.path.substr(this.options.path.length - 1) !== '/') {
      this.options.path = this.options.path + '/';
    }
  },
  methods: {
    upload: function() {
      /*
      Storage.put(this.s3ImagePath, this.file, this.options.storageOptions)
        .then(result => {
          this.completeFileUpload(result.key);
        })
        .catch(e => this.setError(e));
        */
      this.$store
        .dispatch('flats/getUploadUrl', this.options.flat)
        .then(url => {
          console.log(url);
          this.$http.put(url, this.file).then(reply => {
            console.log(reply);
            this.completeFileUpload();
          });
        });
    },
    pickFile: function() {
      this.$refs.file_input.click();
    },
    onPicked: function(evt) {
      this.file = evt.target.files[0];
      if (!this.file) {
        return;
      }
      if (!this.options.storageOptions.contentType) {
        this.options.storageOptions.contentType = this.file.type;
      }
      const name = this.options.defaultName
        ? this.options.defaultName
        : this.file.name;
      this.s3ImagePath = `${this.options.path}${name}`;
      const that = this;
      const reader = new FileReader();
      reader.onload = e => {
        const target = e.target;
        const url = target.result;
        that.photoUrl = url;
      };
      reader.readAsDataURL(this.file);
      console.log(this.file);
    },
    completeFileUpload: function() {
      this.file = null;
      this.s3ImageFile = null;
      this.$refs.file_input.value = null;
      EventBus.$emit('fileUpload');
    },
    setError: function(e) {
      this.error = e.message || e;
      this.logger.error(this.error);
    }
  }
};
</script>
<style >
#fileInput {
  display: none;
}
</style>